module.exports = __webpack_public_path__ + "static/img/protect_6.4d8c0786.png";